import { render, staticRenderFns } from "./INavigation.vue?vue&type=template&id=1e397976"
import script from "./INavigation.vue?vue&type=script&lang=js"
export * from "./INavigation.vue?vue&type=script&lang=js"
import style0 from "./INavigation.vue?vue&type=style&index=0&id=1e397976&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports